import { createIconSetFromIcoMoon } from '@expo/vector-icons';
import { useFonts } from 'expo-font';
import { FC } from 'react';
import { OpaqueColorValue, TextProps } from 'react-native';
type IconProps<T> = TextProps & {
  size?: number;
  name: T;
  color?: string | OpaqueColorValue;
};
export const useIcomoon = () => {
  const [loaded] = useFonts({
    IcoMoon: require('@euler/assets/icomoon/fonts/icomoon.ttf'),
  });
  return loaded;
};
export const Icon = createIconSetFromIcoMoon(
  require('@euler/assets/icomoon/selection.json'),
  'IcoMoon',
  'icomoon.ttf',
) as unknown as FC<IconProps<IconType>>;

export type IconType =
  | 'global'
  | 'sphere'
  | 'warning'
  | 'warning-o'
  | 'settings-outline'
  | 'tools'
  | 'options'
  | 'repair'
  | 'clipboard'
  | 'minus-circle'
  | 'plus-circle'
  | 'stepper-plus'
  | 'stepper-minus'
  | 'video-recorder'
  | 'sheet-checked'
  | 'oil-small'
  | 'lightbulb-on'
  | 'trash-o'
  | 'arrow-right-circle'
  | 'qrcode'
  | 'copy'
  | 'layers'
  | 'share-arrow'
  | 'download-outline'
  | 'file-tray-outline'
  | 'camera-fill'
  | 'camera'
  | 'arrow-back-circle-outline'
  | 'checkmark-circle'
  | 'note'
  | 'scan'
  | 'scan-sharp'
  | 'add-circle-outline'
  | 'hashtag'
  | 'alert-octagon'
  | 'plus'
  | 'history'
  | 'arrow-undo-circle-outline'
  | 'wechat'
  | 'mobile'
  | 'closecircle'
  | 'downcircle'
  | 'hdr-off'
  | 'hdr-on'
  | 'moon'
  | 'moon-outline'
  | 'flash-off-sharp'
  | 'flash-sharp'
  | 'camera-reverse'
  | 'play'
  | 'ios-backspace'
  | 'ios-backspace-outline'
  | 'privacy-policy'
  | 'terms-of-service'
  | 'changelog'
  | 'exclamation-circle-o'
  | 'exclamation-circle-thin'
  | 'throttler'
  | 'smile-comment'
  | 'user-add'
  | 'invite'
  | 'devices'
  | 'restoration'
  | 'endoscope'
  | 'oil-time'
  | 'obd'
  | 'arrow-left-circle'
  | 'close'
  | 'share-alternitive'
  | 'share'
  | 'chevron-thin-right'
  | 'information-solid'
  | 'information-outline'
  | 'notifications-outline'
  | 'notification'
  | 'arrow-thin-left'
  | 'arrow-thin-right'
  | 'search'
  | 'play-circle-alt'
  | 'settings'
  | 'mobile-phone'
  | 'phone-hang-up'
  | 'phone'
  | 'pencil'
  | 'play-circle'
  | 'bars'
  | 'bluetooth'
  | 'user-o'
  | 'user'
  | 'clock'
  | 'more-vertical'
  | 'chevron-left'
  | 'lock'
  | 'bluetooth-o'
  | 'chevron-right'
  | 'check'
  | 'chevron-down'
  | 'error'
  | 'invert_colors_on'
  | 'app_settings_alt'
  | 'clear'
  | 'toys'
  | 'help_outline'
  | 'help'
  | 'home-outline'
  | 'home'
  | 'keyboard_arrow_up'
  | 'radio_button_on'
  | 'radio_button_off'
  | 'checkbox'
  | 'checkbox_outline'
  | 'arrow_circle_up'
  | 'arrow_circle_down'
  | 'arrow_drop_up'
  | 'arrow_drop_down'
  | 'add';
